export const firebaseConfig = {
    apiKey: "AIzaSyDrQu6Ql1L0UhkPMYmM7KckxcK8XP7dZB4",
    authDomain: "homehero-75b1d.firebaseapp.com",
    databaseURL: "https://homehero-75b1d.firebaseio.com",
    projectId: "homehero-75b1d",
    storageBucket: "homehero-75b1d.appspot.com",
    messagingSenderId: "356618601963",
    appId: "1:356618601963:web:60312b641f8f21ca5445ae"
  };